import { Box, Grid } from '@/components//ui'
import { GlobalHeader } from '@/components/shared/GlobalHeader'
import { InquiryListProvider } from '@/components/shared/InquiryList'

type Props = {
  children: React.ReactNode
}

export const GlobalLayout = ({ children }: Props) => {
  return (
    <Grid templateColumns="1fr" templateRows="max-content 1fr" h="svh" w="svw">
      <GlobalHeader />
      <InquiryListProvider>
        <Box overflow="auto">{children}</Box>
      </InquiryListProvider>
    </Grid>
  )
}
